/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PutConfigurationRequest
 */
export interface PutConfigurationRequest {
    /**
     * version from the last read; null when the scope stores nothing yet
     */
    expected_version: number;
    /**
     * The scope's complete override, validated against the key's schema
     */
    value: any | null;
}

/**
 * Check if a given object implements the PutConfigurationRequest interface.
 */
export function instanceOfPutConfigurationRequest(value: object): value is PutConfigurationRequest {
    if (!('expected_version' in value) || value['expected_version'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function PutConfigurationRequestFromJSON(json: any): PutConfigurationRequest {
    return PutConfigurationRequestFromJSONTyped(json, false);
}

export function PutConfigurationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutConfigurationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'expected_version': json['expected_version'],
        'value': json['value'],
    };
}

export function PutConfigurationRequestToJSON(json: any): PutConfigurationRequest {
    return PutConfigurationRequestToJSONTyped(json, false);
}

export function PutConfigurationRequestToJSONTyped(value?: PutConfigurationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expected_version': value['expected_version'],
        'value': value['value'],
    };
}

